import {DefaultService} from "./DefaultService";

class RestaurantCollectionService extends DefaultService {
    getRestaurantCollection(params){
        return this.post('/customer/restaurant-collection-list', params).then(res => res.data)
    }
}

export default RestaurantCollectionService;